(function(){
  "use strict";

  function initTilt(){
    var cards = document.querySelectorAll('[data-tilt]');
    cards.forEach(function(card){
      var inner = card.querySelector('.tilt-inner');
      if(!inner) return;
      var bounds;
      card.addEventListener('mouseenter', function(){ bounds = card.getBoundingClientRect(); });
      card.addEventListener('mousemove', function(e){
        if(!bounds) bounds = card.getBoundingClientRect();
        var x = e.clientX - bounds.left;
        var y = e.clientY - bounds.top;
        var px = x / bounds.width;
        var py = y / bounds.height;
        var rotateX = (0.5 - py) * 14;
        var rotateY = (px - 0.5) * 14;
        inner.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale3d(1.02,1.02,1.02)';
        inner.style.setProperty('--mx', (px * 100) + '%');
        inner.style.setProperty('--my', (py * 100) + '%');
      });
      card.addEventListener('mouseleave', function(){
        inner.style.transform = 'rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      });
    });
  }

  function initBookTilt(){
    var wraps = document.querySelectorAll('[data-book-tilt]');
    var BASE_Y = -18, BASE_X = 3;
    wraps.forEach(function(wrap){
      var inner = wrap.querySelector('.book-3d-inner');
      var glow = wrap.querySelector('.card-glow');
      if(!inner) return;
      var bounds;
      wrap.addEventListener('mouseenter', function(){ bounds = wrap.getBoundingClientRect(); });
      wrap.addEventListener('mousemove', function(e){
        if(!bounds) bounds = wrap.getBoundingClientRect();
        var px = (e.clientX - bounds.left) / bounds.width;
        var py = (e.clientY - bounds.top) / bounds.height;
        var rotateY = BASE_Y + (px - 0.5) * 26;
        var rotateX = BASE_X + (0.5 - py) * 16;
        inner.style.transform = 'rotateY(' + rotateY + 'deg) rotateX(' + rotateX + 'deg) scale3d(1.03,1.03,1.03)';
        if(glow){
          glow.style.setProperty('--mx', (px * 100) + '%');
          glow.style.setProperty('--my', (py * 100) + '%');
        }
      });
      wrap.addEventListener('mouseleave', function(){
        inner.style.transform = 'rotateY(' + BASE_Y + 'deg) rotateX(' + BASE_X + 'deg)';
      });
    });
  }

  function initReveal(){
    var els = document.querySelectorAll('.reveal-up');
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in-view'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function(el){ observer.observe(el); });
  }

  function initCounters(){
    var counters = document.querySelectorAll('.stat-number');
    if(!counters.length) return;
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var duration = 1400;
        var start = null;
        function step(ts){
          if(!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.floor(eased * target);
          el.textContent = value.toLocaleString('fr-FR');
          if(progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toLocaleString('fr-FR');
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach(function(el){ observer.observe(el); });
  }

  function initMobileNav(){
    var btn = document.getElementById('burgerBtn');
    var nav = document.getElementById('mobileNav');
    if(!btn || !nav) return;
    btn.addEventListener('click', function(){
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initHeaderScroll(){
    var header = document.getElementById('siteHeader');
    if(!header) return;
    window.addEventListener('scroll', function(){
      if(window.scrollY > 12) header.style.boxShadow = '0 10px 30px rgba(0,0,0,.35)';
      else header.style.boxShadow = 'none';
    }, { passive: true });
  }

  function initProductThumbs(){
    var thumbs = document.querySelectorAll('.thumb-btn');
    var mainImg = document.getElementById('mainProductImage');
    if(!thumbs.length || !mainImg) return;
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        mainImg.src = btn.getAttribute('data-full');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initTilt();
    initBookTilt();
    initReveal();
    initCounters();
    initMobileNav();
    initHeaderScroll();
    initProductThumbs();
  });
})();
